import React, { useCallback } from 'react'
import { connect as connectStaticText } from '../../../../StaticText/connect'
import { StaticTextProvider, useTranslatedText } from '../../../../StaticText/StaticTextContext'
import { H3 } from '../../../../Heading/index'
import Button, { TYPES as BUTTON_TYPES } from '../../../../Button/index'
import type { StaticTextMap } from '../../../../../services/community/types'

export interface DeletePlaylistConfirmModalProps {
  playlistName: string
  itemCount: number
  onConfirm: () => void
  onCancel: () => void
  staticText: StaticTextMap
}

function DeletePlaylistConfirmModalInner ({
  playlistName,
  itemCount,
  onConfirm,
  onCancel,
}: Omit<DeletePlaylistConfirmModalProps, 'staticText'>) {
  const stTitle = useTranslatedText({ keys: ['deletePlaylistTitle'] })
  const stText1 = useTranslatedText({ keys: ['deletePlaylistText1'] })
  const stText2 = useTranslatedText({ keys: ['deletePlaylistText2'] })
  const stText3 = useTranslatedText({ keys: ['deletePlaylistText3'] })
  const stCancel = useTranslatedText({ keys: ['cancel'] })
  const stDelete = useTranslatedText({ keys: ['delete'] })

  const handleOverlayClick = useCallback(() => {
    onCancel()
  }, [onCancel])

  const handleCardClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation()
  }, [])

  return (
    <div
      className="delete-playlist-confirm-modal__overlay"
      onClick={handleOverlayClick}
      role="presentation"
    >
      <div
        className="delete-playlist-confirm-modal__card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-playlist-confirm-title"
        onClick={handleCardClick}
      >
        <H3
          id="delete-playlist-confirm-title"
          className="delete-playlist-confirm-modal__title"
        >
          {stTitle}
        </H3>
        <p className="delete-playlist-confirm-modal__text">
          {stText1}
          {' '}
          <b>{playlistName}</b>
          {' '}
          {stText2}
          {' '}
          <b>{itemCount}</b>
          {' '}
          {stText3}
        </p>
        <div className="delete-playlist-confirm-modal__actions">
          <Button
            type={BUTTON_TYPES.GHOST}
            className="delete-playlist-confirm-modal__cancel-btn"
            onClick={onCancel}
          >
            {stCancel}
          </Button>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            className="delete-playlist-confirm-modal__delete-btn"
            onClick={onConfirm}
          >
            {stDelete}
          </Button>
        </div>
      </div>
    </div>
  )
}

function DeletePlaylistConfirmModal (props: DeletePlaylistConfirmModalProps) {
  return (
    <StaticTextProvider staticText={props.staticText}>
      <DeletePlaylistConfirmModalInner {...props} />
    </StaticTextProvider>
  )
}

export default connectStaticText({ storeKey: 'deletePlaylistConfirmModal' })(
  React.memo(DeletePlaylistConfirmModal),
)
